import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "assets/scss/dashboard.scss";
import "assets/css/charts_form_controls.css";
import React, { useState, useRef, useLayoutEffect,useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { classNames } from "primereact/utils";
import { InputText } from "primereact/inputtext";
import "assets/css/grid_table.css";
import { getDataApi, saveApi, loadApi } from "services/appApi";
import { pecaPageRows, pecaRowsPerPageOptions } from "pages/common/envPECA";
import axios from "axios";

const DownTimeType  = () => {
  let emptyRow = {
   downtime_type: "",
   downtime_type_desc: null,
   downtime_type_id: null,
  };

  const [rows, setRows] = useState([]);
  const [rowDialog, setRowDialog] = useState(false);
  const [showproductDialog, setShowProductDialog] = useState(false);
  const [row, setRow] = useState(emptyRow);
  const [selectedRows, setSelectedRows] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [dialog, setDialog] = useState("");
  const [errorMessage, setErrorMessage] = useState('');
  const [loadingErrors, setLoadingErrors] = useState([]);
  const [wasDataFetchingSuccessful, setWasDataFetchingSuccessful] =useState(true);
  const [downTimeType, setDownTimeType]=useState("");
  const [downTimeDescription, setDownTimeDescription]=useState("");
  const toast = useRef(null);
  const dt = useRef(null);
 
    const handleLoadData = async () => {
      const p_param = {
        p_downtime_type: downTimeType,
        p_downtime_type_desc: downTimeDescription,
     };
     console.log(p_param);
      try {
        setIsLoading(true);
        const response = await loadApi(p_param,"/api/setup/downtimes/downtimeType/selRows");
        console.log("Fetched Data:", response.data);
        console.log(response.data[0]);
        console.log(response.data[1]);
        if (response.data.length > 0) {
          let successFlag = response.data[0];
          if (successFlag === "Y") {
            toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Data fetched successfully'
            })
            console.log("success=Y");
            setRows(response.data[1]);
            setIsLoading(false);
            setWasDataFetchingSuccessful(false);
          } else {
            //setRows(null);
            setRows([]);
            setIsLoading(false);
            setWasDataFetchingSuccessful(true);
            const errorInfo = response.data[2];
            // Set the error message and display the dialog
            setErrorMessage(errorInfo);
            setErrorDialogVisible(true);
          }
          //setSearch(response.data);
        } else {
          //setRows(null);
          setRows([]);
          setIsLoading(false);
          setWasDataFetchingSuccessful(true);
        }

        //setRows(response.data);
      } catch (error) {
        if(axios.isCancel(error) ||  error.name== 'CanceledError') {
        console.log("Request was cancelled by the user.");

        toast.current.show({
          severity: 'warn',
          summary: 'Cancelled',
          detail: 'Request successfully cancelled by the user.',
          life: 3000,
        })
        setIsLoading(false);
      } else {
        console.error("Error fetching data:", error);
      }
    }
    };

    const saveRow = async () => {
        setSubmitted(true);
    
        if (row.downtime_type.trim()) {
          //      const isNew = !row.downtime_type_id;
          //     const formattedRow = formatDateFields(row, isNew);
    
          let _rows = [...rows];
          let _row = { ...row };
    
          try {
            if (row.downtime_type_id) {
              /*** Update Row */
              const response = await saveApi(row, "/api/setup/downtimes/downtimeType/updRow");
              //await axios.put(`http://localhost:5000/api/machines/${row.downtime_type_id}`, formattedRow);
              //             const updatedRows = rows.map((p) => (p.downtime_type_id === row.downtime_type_id ? formattedRow : p));
              //             setRows(updatedRows);
              console.log("updating");
              console.log(response.data);
              let successFlag = response.data[0];
              if (successFlag === "Y") {
                const index = findIndexById(row.downtime_type_id);
                _rows[index] = _row;
                toast.current.show({
                  severity: "success",
                  summary: "Successful",
                  detail: "DownTime Updated",
                  life: 3000,
                  width: "600px",
                });
              } else {
                let err_msg = response.data[1];
                toast.current.show({
                  severity: "error",
                  summary: err_msg,
                  detail: "DownTime Not Updated",
                  life: 3000,
                  width: "600px",
                });
              }
            } else {
              /*** Insert Row */
              const response = await saveApi(row, "/api/setup/downtimes/downtimeType/insRow");
              //const response = await axios.post('http://localhost:5000/api/machines', formattedRow);
              //       formattedRow.downtime_type_id = response.data.id;
              //     setRows([...rows, formattedRow]);
              console.log("saving");
              console.log("Response data: ", response.data);
              console.log("Response: ", response);
              let successFlag =
                response.data[0]; /** This contains value of Y or N */
              if (successFlag === "Y") {
                _row.downtime_type_id =
                  response.data[1]; /** It contains newly created Id */
                _rows.push(_row);
                toast.current.show({
                  severity: "success",
                  summary: (
                    <div style={{ marginright: "200px", width: "600px" }}>
                      Success
                    </div>
                  ),
                  detail: <div style={{ width: "600px" }}>DownTime Created</div>,
                  life: 3000,
                  width: "600px",
                });
              } else {
                let err_msg = response.data[2];
                toast.current.show({
                  severity: "error",
                  summary: <div style={{ width: "600px" }}>{err_msg}</div>,
                  detail: <div style={{ width: "600px" }}>{err_msg}</div>,
                  life: 3000,
                  width: "600px",
                });
              }
            }
    
            setRows(_rows);
            setRowDialog(false);
            setRow(emptyRow);
          } catch (error) {
            console.error("Error saving DownTime:", error);
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "DownTime Save Failed",
              life: 3000,
              width: "600px",
            });
          }
        } else {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "Please fill in all required fields",
            life: 3000,
            width: "600px",
          });
        }
      };
    

    const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _row = { ...row };
    _row[`${name}`] = val;

    setRow(_row);
  };

  const openNew = () => {
    setRow(emptyRow);
    setSubmitted(false);
    setRowDialog(true);
    setDialog("create")
  };


  const hideDialog = () => {
    setSubmitted(false);
    setRowDialog(false);
    setShowProductDialog(false);
    setErrorDialogVisible(false);
    setDialog("")
  };

  const showProduct = (row) => {
    setRow({ ...row });
    setShowProductDialog(true);
}

const exportCSV = () => {
  dt.current.exportCSV();
};

const getLoadingHeaderContents = () => {
  return (
    <React.Fragment>
      <div className="row d-flex justify-content-center m-5">
        <div className="col-auto">
          <div className="card shadow-sm border-primary">
            <div className="card-header bg-primary text-white">
              <h2 className="mb-0">
              DownTime Type - Inquire
              </h2>
            </div>
            <div className="card-body text-center">
              <h3>
                <i className="fa-duotone fa-fw fa-spin-pulse fa-loader me-3"></i>{" "}
                The page is loading...
              </h3>
            </div>
          </div>
        </div>
      </div>

    </React.Fragment>
  );
}

const getLoadedHeaderContents = () => {
  return (
    <React.Fragment>
      <div className="header-container">
      <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
      DownTime Type - Inquire
        </h2>
      </div>
    </React.Fragment>
  );
}
const getErrrorMsgContents = () => {
  return (
    <React.Fragment>
      <div class="row mt-5 justify-content-md-center">
        <div class="col-3">
          <div class="card border-secondary">
            <div class="card-header bg-dark text-white">
            DownTime Type - Inquire table is Unavailable
            </div>
            <div class="card-body card-body-error rounded-bottom">
              <ul>
                {loadingErrors.map((error) => (
                  <li>
                    error
                  </li>
                ))}

              </ul>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
const getSearchControls = () => (
  <React.Fragment>
    <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
    <label className="form-label">Search</label>
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          disabled={isLoading}
          className="input-outline" />
           </div>
  </React.Fragment>
);

const getDownTimeTypeControl = () => (
  <React.Fragment>
    <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
    <label className="form-label">DownTime Type</label>
          <InputText 
          type="text"
          id = "downTimeType"
          name="downTimeType" 
          onChange={(e) => setDownTimeType(e.target.value)}
          placeholder="Enter DownTime Type"
          disabled={isLoading}
          className="input-outline" />
           </div>
  </React.Fragment>
);
const getDownTimeDescriptionControl = () => (
  <React.Fragment>
    <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
    <label className="form-label">DownTime Description</label>
          <InputText 
          type="text"
          id = "downTimeDescription"
          name="downTimeDescription" 
          onChange={(e) => setDownTimeDescription(e.target.value)}
          placeholder="Enter DownTime Description"
          disabled={isLoading}
          className="input-outline" />
           </div>
  </React.Fragment>
);
  
const getGoButtonControl = () => (
  <React.Fragment>
      <div className="col-auto d-flex align-items-center justify-content-center ps-2 pe-0" style={{paddingTop:'1.9375rem'}}>
        <button
          type="button"
          className="btn btn-primary load-button"
          id={"chartAreaId"}
          onClick={handleLoadData}
          disabled={isLoading}
        >
           <i
            className={
              isLoading ? "fa-duotone fa-fw fa-rotate fa-spin" : "fa-duotone fa-fw fa-rotate"
            }
          ></i>
          <span>{isLoading ? "Loading" : "Go"}</span>
        </button>
      </div>
  </React.Fragment>
  );

  const header = (
    <div className="flex flex-column md:flex-row md:align-items-center justify-content-between">
      {/* <span className="p-input-icon-right w-full md:w-auto">
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto"
        />
      </span> */}
     <div className="mt-1 md:mt-0 flex md:flex-1 justify-content-end">
      <Button
                // label="New"
                icon="pi pi-plus"
                className="p-button-success  p-button-rounded p-mr-2"
                onClick={openNew}
                tooltip="New"
                tooltipOptions={{ position: "bottom" }}
                //disabled={true}
              />
        <Button
          icon="pi pi-upload"
          className="p-button-primary p-button-rounded"
          onClick={exportCSV}
          tooltip="Export"
          tooltipOptions={{ position: "bottom" }}
          style={{ marginLeft: "20px" }}
        />
      </div>
    </div>
  );

   const actionBodyEditTemplate = (rowData) => {
      return (
        <React.Fragment>
          <Button
            icon="pi pi-pencil"
            className="p-button-rounded p-button-success p-mr-2"
            onClick={() => editRow(rowData)}
            tooltip="Edit"
            tooltipOptions={{ position: "bottom" }}
            // disabled={true}
          />
        </React.Fragment>
      );
    };

     const findIndexById = (id) => {
    let index = -1;
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].downtime_type_id === id) {
        index = i;
        break;
      }
    }
    return index;
  };

    const editRow = (row) => {
    setRow({ ...row });
    setRowDialog(true);
    setDialog("edit")
  };


  const readBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-primary"
          onClick={() => showProduct(rowData)}
          tooltip="View"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

  const inputBoxStyle = {
    backgroundColor:"rgb(235, 235, 235)",
    padding: "6px 10px",
    borderRadius: "4px",
    display: "block",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    flexGrow: 1,
    minWidth: 0,
  }

  return (
    <div>
      <Toast ref={toast} />
      <div className="col mx-2">
      {getLoadedHeaderContents()}
      <div className="row">
      <div className="col">
        <div className="row justify-content-center">
          {getSearchControls()} 
          {getDownTimeTypeControl()} 
          {getDownTimeDescriptionControl()}
          {getGoButtonControl()}
        </div>
      {!wasDataFetchingSuccessful && (
      <div className="card my-3">
        {/* <div className="text-3xl text-800 font-bold mb-4">DXP Poll Data Files</div> */}
        <DataTable
          ref={dt}
          value={rows}
          scrollable scrollHeight="flex"     
          selection={selectedRows}
          onSelectionChange={(e) => setSelectedRows(e.value)}
          dataKey="downtime_type_id"
          className="custom-datatable-border"
          tableStyle={{ minWidth: '50rem' }}
          paginator
          rows={pecaPageRows}
          rowsPerPageOptions={pecaRowsPerPageOptions}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} data"
          globalFilter={globalFilter}
          header={header}
          emptyMessage="No data found"
          stripedRows
          showGridlines
        >
         
          <Column body={readBodyTemplate} exportable={false} style={{width:'0.75rem' }}></Column>
          <Column field="downtime_type" header="DownTime Type" sortable style={{whiteSpace: 'nowrap' }}></Column>
          <Column field="downtime_type_desc" header="DownTime Description" sortable style={{whiteSpace: 'nowrap' }}></Column>
          <Column
                          body={actionBodyEditTemplate}
                          style={{ width: "0.75rem" }}
                        ></Column>
        </DataTable>
      </div>
      )}
      </div>
      </div>

      <Dialog visible={showproductDialog} style={{ width: '600px' }} header="DownTime Type - Inquire" modal className="p-fluid" onHide={hideDialog}>
                
                <label htmlFor="downtime_type">DownTime Type</label>
                    <div className="box">
                        {row.downtime_type}
                    </div>

                <label htmlFor="downtime_type_desc">DownTime Description</label>
                    <div className="box">
                        {row.downtime_type_desc}
                    </div>

            </Dialog>
            <Dialog visible={rowDialog} style={{ width: '600px' }} header= {dialog === "edit" ? "Downtime Type - Edit" : dialog === "create" ? "Create New Downtime Type" : ""} modal className="p-fluid" onHide={hideDialog}>
                
                <label htmlFor="downtime_type">DownTime Type</label>
                    <div style={{paddingTop: '10px', paddingBottom: '20px'}}>
                        <InputText
                                      id="downtime_type"
                                      value={row.downtime_type}
                                      onChange={(e) => onInputChange(e, "downtime_type")}
                                      required
                                      autoFocus
                                      className={classNames({
                                        "p-invalid": submitted && row.downtime_type=="",
                                      })}
                                      style={inputBoxStyle}
                                    />
                                    {submitted && row.downtime_type == "" && (
                                      <small className="p-error">DownTime Type is required.</small>
                                    )}
                    </div>
                <label htmlFor="downtime_type_desc">DownTime Description</label>
                     <div style={{paddingTop: '10px',paddingBottom: '20px'}}>
                        <InputText
                                      id="downtime_type_desc"
                                      value={row.downtime_type_desc}
                                      onChange={(e) => onInputChange(e, "downtime_type_desc")}
                                      required
                                      autoFocus
                                      style={inputBoxStyle}
                                    />
                    </div>
                    <div className="btn-container">
                              <Button
                                label="Cancel"
                                icon="pi pi-times"
                                className="p-button-text"
                                onClick={hideDialog}
                                style={{"width":"20%","backgroundColor":"#0d6efd", "color":"white", "borderRadius":"4px", "cursor":"pointer"}}
                              />
                              <Button
                                label="Save"
                                icon="pi pi-check"
                                className="p-button-text"
                                onClick={saveRow}
                                style={{"width":"20%","backgroundColor":"#0d6efd", "color":"white", "borderRadius":"4px", "cursor":"pointer"}}
                              />
                              </div>

            </Dialog>
            <Dialog 
                header="API Error" 
                visible={errorDialogVisible} 
                style={{ width: '400px' }} 
                onHide={hideDialog} 
                footer={
                    <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
                }
            >    
             <p>

                    {errorMessage}
                </p>
            </Dialog>
            <style jsx>{`
                      .btn-container {
                      display: flex;
                      justify-content: center;
                      gap:20px;
                      margin-top:20px;
                      }
                    `}
                    </style>
            </div>
    </div>
  );
};

export default DownTimeType;

